import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import PaginatorCustom from '../../../../components/paginationCustom';
import { getClaimHistory } from './actions/ManageClaimActions';
import SortingCustom from '../../../../components/SortingCustom';
import { reduxForm, reset } from 'redux-form';
import SmallLoader from '../../../../img/small-loader.gif';
import { showFormatedDate, resetFiltersAndSorting, showFormatedDateandTime } from '../../../../actions/utilAction';

class ClaimHistoryDataModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ClaimId: props.claimHistoryId,
            open: true
        };
        this.filter = {
            sort_Column: 'logdate',
            sort_Order: 'desc',
            searchText: '',
        };
        this.setSortColumn = this.setSortColumn.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearchClaimId = this.handleSearchClaimId.bind(this);
    }
    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'logDate',
            sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
            contain_filters: {
                ClaimId: this.state.ClaimId ? this.state.ClaimId : null,
                // FromDate: this.state.FromDate ? this.state.FromDate : '',
                // ToDate: this.state.ToDate ? this.state.ToDate : '',
            },
            pageNumber: page_number ? page_number : 1,
            // pageSize: GlobalVariables.pageSize,
        };
        this.props.getClaimHistory(searchObj);
    }
    componentWillMount() {
        this.loadData();
    }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;

            this.loadData();
        }
    }
    handleSearchClaimId(event) {
        // event.preventDefault();
        this.setState({
            ClaimId: event.ClaimId ? event.ClaimId : '',
        }, () => {
            this.loadData();
        });
    }
    handleReset = () => {
        this.props.dispatch(reset('ClaimHistoryDataModalForm'));
        resetFiltersAndSorting(this.filter, 'claimid', true);
        this.setState({
            ClaimId: null,

        }, () => {
            this.loadData();
        });
    };
    renderData() {
        return this.props.claimHistoryData.data.ClaimHistory.map((data, index) => {
            return (
                <tr key={index}>
                    <td>{showFormatedDateandTime(data.logDate)}</td>
                    <td>{data.loggedBy}</td>
                    <td>{data.action}</td>
                    <td>{data.columnName || '-'}</td>
                    <td>{data.oldValue || '-'}</td>
                    <td>{data.newValue || '-'}</td>
                </tr>
            );
        });
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ?
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                    : null}
            </div>
        );
    }


    render() {
        let claimDetail = null;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        if (this.props.claimHistoryData.data && this.props.claimHistoryData.data.ClaimDetail) {
            claimDetail = this.props.claimHistoryData.data.ClaimDetail;
        }
        return (
            <Dialog className="custom_modal_new_appointment"
                title='Claim History'
                modal={false}
                open={this.state.open}
                autoScrollBodyContent={true}>
                {this.renderLoading()}

                <div>
                    <div className="clearfix"></div>
                    <div className="readmin-panel mt-20">
                        <div className="panel-body">
                            <div className="col-sm-12 mtm-40">
                                {/* <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchClaimId)}>
                <div className="col-sm-4">
                  <Field name="ClaimId"
                    autoFocus={true}
                    floatingLabelText="Claim Id"
                    // onChange={this.handleSearchChange}
                    component={renderTextField} />
                </div>

                <div className="row">
                  <div className="col-sm-12 btn_rt reset-btn">
                    <RaisedButton label="Filter" className="grey_btn" type="Submit" primary={true} />
                    <RaisedButton label="Reset" className="grey_btn ml_15" onTouchTap={this.handleReset} />
                  </div>
                </div>
              </form> */}
                                <div className="row cliam_hisdeatil">
                                    <div className="col-sm-4">
                                        <p>Claim Id : <span>{claimDetail ? 'CL' + claimDetail.claimId : '-'}</span> </p>
                                    </div>
                                    {/* <div className="col-sm-6">
                                        <p>DOS : <span>{claimDetail ? showFormatedDate(claimDetail.dos) : '-'}</span></p>
                                    </div> */}
                                    <div className="col-sm-4">
                                        <p>Client Name : <span>{claimDetail ? claimDetail.patientName : '-'}</span></p>
                                    </div>
                                    <div className="col-sm-4">
                                        <p>Insurance Company : <span>{claimDetail ? claimDetail.payer : '-'}</span></p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="table-responsive mt-15">
                                        {this.props.claimHistoryData.data && this.props.claimHistoryData.data.ClaimHistory && this.props.claimHistoryData.data.ClaimHistory.length ?
                                            <table className={tableClass}>
                                                <thead>
                                                    <tr>
                                                        <th width="22%"><SortingCustom setSortColumn={this.setSortColumn} columnName='logdate' displayName='Log Date' /></th>
                                                        <th width="16%"><span>Logged By</span></th>                                                    
                                                        <th width="20%"><span>Action</span></th>                                                    
                                                        <th width="15%"><span>Field</span></th>
                                                        <th width="12%"><span>Old Value</span></th>
                                                        <th width="15%"><span>New Value</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.renderData()}
                                                </tbody>
                                            </table>
                                            :
                                            <table className={tableClass}>
                                                <thead>
                                                    <tr>
                                                        <th width="22%"><span>Log Date</span></th>   
                                                        <th width="16%"><span>Logged By</span></th>
                                                        <th width="20%"><span>Action</span></th>                                                    
                                                        <th width="15%"><span>Field</span></th>
                                                        <th width="12%"><span>Old Value</span></th>
                                                        <th width="15%"><span>New Value</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="6">
                                                            <div className="familydl text-center no-record">No record found!</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        }

                                        {this.props.claimHistoryData.data && this.props.claimHistoryData.data.ClaimHistory && this.props.claimHistoryData.data.ClaimHistory.length ?
                                            <PaginatorCustom data={this.props.claimHistoryData.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                            : null}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 pt20 btn_rt">
                    <FlatButton className="grey_btn" label="Cancel" onTouchTap={this.handleClose} />
                </div>
            </Dialog>
        );
    }
}
ClaimHistoryDataModal = reduxForm({
    form: 'ClaimHistoryDataModalForm',
})(ClaimHistoryDataModal);

function mapStateToProps(state) {
    return {
        loading: state.billing.loading,
        claimHistoryData: state.billing.claimHistoryData,
    };

}
export default connect(mapStateToProps, { getClaimHistory })(ClaimHistoryDataModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/CliamHistoryModal.js